'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("itTreeTableRow", function () {
  return {
    restrict: "A",
    scope: true,
    require: ["^infiniTable", "itTreeTableRow"],
    link: function link($scope, $el, $attrs, controllers) {
      var treeCtrl = controllers[0],
        rowCtrl = controllers[1];
      rowCtrl.setTableCtrl(treeCtrl);
    },
    controller: function controller($scope) {
      var ctrl = this,
        tableCtrl = null,
        renderer = null;
      ctrl.setTableCtrl = function (_treeCtrl) {
        tableCtrl = _treeCtrl;
        renderer = tableCtrl.getRenderer();
      };
      ctrl.getScope = function () {
        return $scope;
      };
      ctrl.getNode = function () {
        return $scope.data;
      };
      ctrl.isExpanded = function () {
        return $scope.data.expanded;
      };
      ctrl.toggleCollapse = function (recursive) {
        ctrl.isExpanded() ? ctrl.collapse(recursive) : ctrl.expand(recursive);
      };
      ctrl.expand = function (recursive) {
        renderer.expandNode($scope.data.nodeId, recursive);
      };
      ctrl.collapse = function (recursive) {
        renderer.collapseNode($scope.data.nodeId, recursive);
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/tree/itTreeTableRow.js
// module id = 2822
// module chunks = 13